var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filter-button small",class:{active: _vm.active},on:{"click":function($event){return _vm.setFilter(_vm.value)}}},[_c('img',{style:({width: '3rem', paddingTop: '0.25rem'}),attrs:{"src":'./icons/'+_vm.value+'W.svg'}})])}
var staticRenderFns = []

export { render, staticRenderFns }